// extracted by mini-css-extract-plugin
export default {"departments":"KG-z","departmentHeading":"LG-z","departmentSection":"MG-z","departmentName":"NG-z","departmentLink":"OG-z","expandIcon":"PG-z"};